import { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { signUp } from 'aws-amplify/auth';

const SignUp = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    const aliasParam = searchParams.get('alias');
    
    if (tokenParam && aliasParam) {
      setToken(tokenParam);
      setEmail(`${aliasParam}@amazon.com`);
    }
  }, [searchParams]);

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    // 비밀번호 일치 확인
    if (password !== confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      setLoading(false);
      return;
    }
    
    try {
      const signUpOptions = {
        username: email,
        password,
        options: {
          userAttributes: {
            email,
            'custom:alias': email.replace('@amazon.com', '')
          }
        }
      };

      // 토큰 정보를 clientMetadata로 전달
      if (token) {
        signUpOptions.options.clientMetadata = {
          token: token
        };
      }

      const { isSignUpComplete, nextStep } = await signUp(signUpOptions);
      
      // 회원가입 요청 성공 - 수동 승인 대기 메시지 표시
      alert('회원가입 요청이 완료되었습니다!\n\n회사 내부 정책에 의해 인증을 수동으로 진행합니다.\n곧 Slack DM으로 본인 확인 요청 드리도록 하겠습니다.\n잠시만 기다려 주세요.');
      navigate('/signin');
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <h2>회원가입</h2>
      <form onSubmit={handleSignUp}>
        <div className="form-group">
          <label>이메일</label>
          <input
            type="email"
            value={email}
            readOnly
            required
            placeholder="example@amazon.com"
            style={{
              backgroundColor: '#f5f5f5',
              color: '#666',
              cursor: 'not-allowed'
            }}
          />
          <small className="email-notice">오직 @amazon.com 도메인만 허용됩니다</small>
        </div>
        <div className="form-group">
          <label>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="비밀번호를 입력하세요"
          />
        </div>
        <div className="form-group">
          <label>비밀번호 확인</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            placeholder="비밀번호를 다시 입력하세요"
          />
        </div>
        {/* Hidden field for token */}
        {token && <input type="hidden" name="token" value={token} />}
        {error && <p className="error">{error}</p>}
        {loading && (
          <div className="loading-container">
            <div className="progress-bar">
              <div className="progress-bar-fill"></div>
            </div>
            <p>가입 처리 중...</p>
          </div>
        )}
        <button type="submit" disabled={loading}>
          {loading ? '처리 중...' : '가입하기'}
        </button>
      </form>
      <p className="auth-link">
        이미 계정이 있으신가요? <Link to="/signin">로그인</Link>
      </p>
    </div>
  );
};

export default SignUp;
